import { Box } from '@mui/material';
import CostTooltipCard from './CostTooltipCard';

export default function LCUSDField({ value, row }) {
	return (
		<CostTooltipCard row={row}>
			<Box>{value}</Box>
		</CostTooltipCard>
	);
}
